import { render } from "./Main.vue?vue&type=template&id=4837ee47&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=4837ee47&lang=css"
import "./Main.vue?vue&type=style&index=1&id=4837ee47&lang=css"
import "./Main.vue?vue&type=style&index=2&id=4837ee47&scoped=true&lang=css"
import "./Main.vue?vue&type=style&index=3&id=4837ee47&lang=css"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4837ee47"]])

export default __exports__